var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagramLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.68,
    height: 43.679,
    viewBox: "0 0 43.68 43.679",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-2",
    x1: 36.156,
    x2: 7.499,
    y1: 38.309,
    y2: 5.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "rgb(93,63,210)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    stopColor: "rgb(184,41,169)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.501,
    stopColor: "rgb(190,40,157)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.638,
    stopColor: "rgb(208,37,126)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.785,
    stopColor: "rgb(230,34,86)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815,
    stopColor: "rgb(232,49,86)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.872,
    stopColor: "rgb(238,87,85)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "rgb(248,149,84)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(255,193,83)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#linearGradient-2)",
    fillRule: "evenodd",
    d: "M21.8397917 0C9.78082465 0 0 9.78058252 0 21.83925104c0 12.05866852 9.78082465 21.83925104 21.8397917 21.83925104 12.05896704 0 21.8397917-9.78058252 21.8397917-21.83925104C43.6795834 9.75020804 33.89875873 0 21.8397917 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M29.64621876 21.80887317c0 4.31323243-3.4931488 7.80627442-7.80644226 7.80627442-4.3132782 0-7.806427-3.493042-7.806427-7.80627442 0-4.31317138 3.4931488-7.80621337 7.806427-7.80621337 4.31329345 0 7.80644226 3.49304199 7.80644226 7.80621337zm-7.83680725-5.89263916c-3.2501526 0-5.89279175 2.67297364-5.89279175 5.92303467 0 3.25006104 2.64263916 5.89263916 5.89279175 5.89263916 3.25015258 0 5.89279174-2.64257812 5.89279174-5.89263916 0-3.28045654-2.64263916-5.92303467-5.89279174-5.92303467z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M14.06372974 34.77878284h15.55210877c2.91603088 0 5.28529358-2.36920166 5.28529358-5.31555176V14.15451526c0-2.91595459-2.3692627-5.28515625-5.28529358-5.28515625H14.06372974c-2.91603088 0-5.28529358 2.36920166-5.28529358 5.28515625V29.4936266c0 2.9159546 2.3692627 5.28515625 5.28529358 5.28515625zm-3.37164306-20.5939331c0-1.85284424 1.5187683-3.371521 3.37165832-3.371521v-.0303955h15.55210877c1.85289001 0 3.37165832 1.51873779 3.37165832 3.37158202V29.4936266c0 1.85284424-1.5187683 3.37158203-3.37165832 3.37158203H14.063745c-1.85289001 0-3.37165832-1.51873779-3.37165832-3.37158203V14.18484974z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgb(255,255,255)",
    fillRule: "evenodd",
    d: "M29.73735198 13.1521498c-.6682551 0-1.24538451.54674063-1.24538451 1.24535367 0 .66823855.54675417 1.2149792 1.2453845 1.2149792.6682551 0 1.24538451-.54674065 1.24538451-1.2149792-.03037523-.69861304-.5771294-1.24535368-1.2453845-1.24535368z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramLogo);
export default __webpack_public_path__ + "static/media/instagram_logo.b3085c69a8a59cde19fb6d34d1987063.svg";
export { ForwardRef as ReactComponent };